import { getSun } from '~/composables/app/getSun'

interface Params {
  resourceValue: number
  rentDuration: number
  rentTimeUnit: string
}
interface Result { payAmount: number; serviceAmount: number; sun: number }

export function getPayAmountByResource(params: Params): Result {
  const { config } = useAppState()

  const result: Result = {
    payAmount: 0,
    serviceAmount: 0,
    sun: 0,
  }

  result.sun = getSun(params.rentDuration, params.rentTimeUnit)

  if (params.rentTimeUnit === 'h') {
    // 小时的计算方式
    result.payAmount = (params.resourceValue * result.sun) / 1000000
  }
  else if (params.rentTimeUnit === 'd') {
    // 天的计算方式
    if (params.rentDuration < 1 || params.rentDuration > 30)
      return result

    result.payAmount = ((params.resourceValue * result.sun) / 1000000) * params.rentDuration
  }

  if (params.resourceValue < (config.value?.price_b2c.energy?.service_amount_limit || 0)) {
    result.serviceAmount = config.value?.price_b2c.energy?.service_amount || 0
    result.payAmount += result.serviceAmount
  }

  return result
}
